<div class="mb-4">
  @if(label){
  <label class="field-label" [class.!mb-4]="optionWrapperClass">
    {{ label }}
    @if (isRequired) {
      <span class="text-red-600" aria-hidden="true">*</span>
    }
  </label>
  @if (otherInfo) {
  <p class="text-dc-navy! mb-2">{{ otherInfo }}</p>
  } }
  <div class="space-y-2">
    @for (option of options; track option) {
    @if (optionWrapperClass) {
    <div
      [class]="optionWrapperClass"
      [class.card-edge-cut-grey]="isChecked(option.value)"
    >
      <label
        class="flex items-center gap-x-6 p-6 z-10 cursor-pointer relative"
        [class.items-start]="isStacked"
      >
        <input
          type="checkbox"
          [checked]="isChecked(option.value)"
          (change)="onCheckboxChange(option.value, $event)"
          [disabled]="disabled || option?.disabled"
          class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none disabled:cursor-not-allowed"
        />
        @if (isChecked(option.value)) {
          <span
            class="h-6 w-6 font-sans text-white text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy peer-disabled:bg-gray-200 peer-disabled:border-gray-300"
          >
            <i class="fas fa-check"></i>
          </span>
        }
        <span
          class="text-dc-navy"
          [class.flex]="isStacked"
          [class.flex-col]="isStacked"
        >
          <span [class.font-semibold]="isStacked">
            @if (translateOptions) {
              {{ option?.label | translate }}
            } @else {
              {{ option?.label }}
            }
          </span>
          @if (isStacked && option?.description) {
            <span class="mt-1 font-normal text-dc-navy">
              @if (translateOptions) {
                {{ option?.description | translate }}
              } @else {
                {{ option?.description }}
              }
            </span>
          }
        </span>
      </label>
    </div>
    } @else {
    <label
      class="flex items-center gap-x-2 cursor-pointer relative"
      [class.items-start]="isStacked"
    >
        <input
        type="checkbox"
        [checked]="isChecked(option.value)"
        (change)="onCheckboxChange(option.value, $event)"
        [disabled]="disabled || option?.disabled"
        class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none disabled:cursor-not-allowed"
      />
      @if (isChecked(option.value)) {
        <span
          class="h-6 w-6 font-sans text-white text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy peer-disabled:bg-gray-200 peer-disabled:border-gray-300"
        >
          <i class="fas fa-check"></i>
        </span>
      }
      <span
        class="text-dc-navy"
        [class.flex]="isStacked"
        [class.flex-col]="isStacked"
      >
        <span [class.font-semibold]="isStacked">
          @if (translateOptions) {
            {{ option?.label | translate }}
          } @else {
            {{ option?.label }}
          }
          @if (isRequired && options.length === 1) {
            <span class="text-red-600" aria-hidden="true">*</span>
          }
        </span>
        @if (isStacked && option?.description) {
          <span class="mt-1 font-normal text-dc-navy">
            @if (translateOptions) {
              {{ option?.description | translate }}
            } @else {
              {{ option?.description }}
            }
          </span>
        }
      </span>
    </label>
    }
    }

    <div class="fields-error-container">
      <!-- Show custom error messages -->
      @if (control.touched && control.invalid) { @for (errorKey of errorKeys;
      track errorKey) { @if (control.hasError(errorKey)) {
      {{
        validationMessages[errorKey] ||
          (errorKey === "required" || errorKey === "requiredTrue"
            ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
            : "Invalid value")
      }}
      <br />
      } } }
    </div>
  </div>
</div>
